"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _uiKit = require("@dbi-tools/ui-kit");

var _columnLayout = require("./column-layout.styled");

var _useMedia = require("../../hooks/use-media");

var _const = require("../../const");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ColumnLayoutUi = function ColumnLayoutUi(props) {
  var storyItems = props.storyItems,
      _props$isStorybook = props.isStorybook,
      isStorybook = _props$isStorybook === void 0 ? false : _props$isStorybook,
      id = props.id,
      removeBottomPadding = props.removeBottomPadding,
      removeTopPadding = props.removeTopPadding,
      children = props.children,
      expandedItemsInit = props.expandedItems,
      enableHorizontalLine = props.enableHorizontalLine,
      title = props.title;

  if ((0, _isEmpty.default)(children) && (0, _isEmpty.default)(storyItems)) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      align: "center",
      as: "h2",
      fontWeight: "bold",
      measure: "h1"
    }, "Please configure Column Layout component");
  }

  var _useState = (0, _react.useState)(expandedItemsInit),
      _useState2 = _slicedToArray(_useState, 1),
      expandedItems = _useState2[0];

  var isDesktop = (0, _useMedia.useMedia)(_const.Breakpoints.DESKTOP);
  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  var defaultPadding = isMobile ? 30 : 60;
  var bottomIndent = removeBottomPadding ? 0 : defaultPadding;
  var topIndent = removeTopPadding ? 0 : defaultPadding;
  var containerIndent = [topIndent, 0, bottomIndent];

  var body = function body(item) {
    return /*#__PURE__*/_react.default.createElement(_columnLayout.ColumnLayoutItemWrapStyled, null, item);
  };

  var getColumns = function getColumns(items) {
    var defaultCol = 12 / items;
    if (isDesktop) return defaultCol;
    if (isMobile) return 12;
    return items > 3 ? defaultCol : 6;
  };

  var columnLayoutContent = (0, _react.useMemo)(function () {
    return !(0, _isEmpty.default)(children) && _react.default.Children.map(children, function (item, index) {
      return /*#__PURE__*/_react.default.createElement(_columnLayout.ColumnLayoutItemStyled, {
        col: getColumns(children.length),
        key: index
      }, body(item));
    });
  }, [_toConsumableArray(expandedItems)]);
  var columnLayoutContentStory = (0, _react.useMemo)(function () {
    return !(0, _isEmpty.default)(storyItems) && storyItems.map(function (_ref, index) {
      var content = _ref.content;
      return /*#__PURE__*/_react.default.createElement(_columnLayout.ColumnLayoutItemStyled, {
        col: getColumns(storyItems.length),
        key: index
      }, body(content));
    });
  }, [_toConsumableArray(expandedItems)]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    id: id,
    p: containerIndent,
    color: "gray800",
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_COLUMN_LAYOUT
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Container, null, title && /*#__PURE__*/_react.default.createElement(_columnLayout.ColumnLayoutTitleStyled, null, title), /*#__PURE__*/_react.default.createElement(_columnLayout.ColumnLayoutUiStyled, null, isStorybook ? columnLayoutContentStory : columnLayoutContent), enableHorizontalLine && (0, _isEmpty.default)(storyItems) && /*#__PURE__*/_react.default.createElement(_columnLayout.ColumnLayoutLineStyled, null))));
};

var _default = ColumnLayoutUi;
exports.default = _default;